<template>
  <div>
    <b-modal
      id="modal-prevent-closing-pay"
      ref="modal-pay"
      v-model="showModal"
      hide-footer
      centered
    >
      <template #modal-title> Pay </template>

      <validation-observer ref="pay">
        <div class="py-1">
          <h4 class="font-weight-normal">You selected {{ item.name }}</h4>
          <h4 class="font-weight-normal">
            Total pay amount {{ parseFloat(paymentPrice) }} $
          </h4>
        </div>
        <b-form class="auth-add-user-form my-2" @submit.prevent="pay">
          <hr />
          <div class="my-2">
            <div
              class="w-100 d-flex align-items-center justify-content-end warning-button"
            >
              <label class="mr-50 mb-0 pt-25" for="pay-with-wallet"
                >Pay with wallet</label
              >

              <b-form-checkbox
                v-model="payWithWallet"
                name="pay-with-wallet"
                id="pay-with-wallet"
                class="mr-0"
                switch
                inline
                :uncheckedValue="0"
                :value="1"
              >
              </b-form-checkbox>
            </div>
            <div
              class="my-1 d-flex align-items-center"
              v-if="payWithWallet && currentBalance"
            >
              <label class="mb-0 mr-50">Current balance:</label>
              <div>{{ parseFloat(currentBalance) }} $</div>
            </div>
            <b-form-group
              label-for="name"
              class="w-100"
              label="The amount of the payment from the wallet:"
              v-if="payWithWallet && currentBalance"
            >
              <validation-provider
                #default="{ errors }"
                name="Amount"
                :rules="`required|min-value:0|max-value:${
                  parseFloat(currentBalance) < parseFloat(paymentPrice)
                    ? parseFloat(currentBalance)
                    : parseFloat(paymentPrice)
                }`"
              >
                <b-form-input
                  min="0"
                  type="number"
                  id="Amount"
                  v-model="customPrice"
                  name="Amount"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <hr
            v-if="
              payWithWallet
                ? parseFloat(currentBalance) < parseFloat(paymentPrice)
                  ? true
                  : parseFloat(customPrice) < parseFloat(paymentPrice)
                : true
            "
          />
          <b-form-group
            label-for="type"
            class="w-100"
            label="Choose a payment method"
            v-if="
              payWithWallet
                ? parseFloat(currentBalance) < parseFloat(paymentPrice)
                  ? true
                  : parseFloat(customPrice) < parseFloat(paymentPrice)
                : true
            "
          >
            <b-row>
              <b-col
                class="d-flex px-50"
                md="4"
                cols="6"
                v-for="(item, index) in types"
                :key="index"
              >
                <div
                  @click="
                    type = item.value;
                    currency = item.currency ? item.currency : '';
                  "
                  :class="`shadow-lg rounded ${
                    type == item.value ? '  selected ' : ' opacity-50 '
                  } cursor-pointer bg-secondary d-flex align-items-center justify-content-center w-100 my-50 p-1`"
                  style="height: 80px"
                >
                  <b-badge
                    v-if="type == item.value"
                    variant="warning"
                    class="rounded-circle p-25"
                    style="position: absolute; top: -15px; right: 20px"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      style="width: 12px; height: 12px"
                    />
                  </b-badge>
                  <b-img
                    :alt="item.title"
                    :src="item.img"
                    fluid
                    style="max-height: 40px"
                  />
                </div>
              </b-col>
              <b-col class="d-flex" cols="12">
                <div
                  @click="
                    type = crypto.value;
                    currency = crypto.currency ? crypto.currency : '';
                  "
                  :class="`shadow-lg rounded ${
                    type == crypto.value ? 'border-warning' : 'border'
                  } cursor-pointer d-flex align-items-center justify-content-center w-100 my-50 p-1`"
                  style="height: 80px"
                >
                  <b-badge
                    v-if="type == crypto.value"
                    variant="warning"
                    class="rounded-circle p-25"
                    style="position: absolute; top: -15px; right: 20px"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      style="width: 12px; height: 12px"
                    />
                  </b-badge>
                  <h3>
                    {{ crypto.title }}
                  </h3>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
          <b-button block type="submit" class="my-1 gradient-btn">
            pay
          </b-button>
        </b-form>
      </validation-observer>
      <loader :loading="loading" />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButtonGroup,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BBadge,
  BCardTitle,
  BCardText,
  BModal,
  BAvatar,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    BRow,
    BImg,
    BBadge,
    BCol,
    BLink,
    BButtonGroup,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BModal,
    Loader,
    BAvatar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    payType: {
      type: String,
      default: "",
    },
  },
  computed: {
    showModal: {
      set(newVal) {
        this.payWithWallet = false;
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
    paymentPrice() {
      return this.payType == "register" ? this.item.fee : this.item.award;
    },
  },
  data() {
    return {
      payWithWallet: false,
      currentBalance: "",
      customPrice: "",
      amount: "",
      type: "STRIPE1",
      loading: false,
      currency: "",
      crypto: {
        value: "NOW_PAYMENT1",
        title: "Pay with crypto",
        currency: "usdt",
      },
      types: [
        {
          value: "STRIPE1",
          title: "master card",
          img: require("@/assets/images/fxlegends/MasterCard-Logo-1990.png"),
        },
        {
          value: "STRIPE2",
          title: "visa card",
          img: require("@/assets/images/fxlegends/Visa_Inc._logo.svg.png"),
        },
        {
          value: "STRIPE3",
          title: "debit card",
          img: require("@/assets/images/fxlegends/debit.png"),
        },
        // {
        //   value: "NOW_PAYMENT1",
        //   title: "tether",
        //   img: require("@/assets/images/fxlegends/tether-1.svg"),
        //   currency: "usdt",
        // },
        // {
        //   value: "NOW_PAYMENT2",
        //   title: "btc",
        //   img: require("@/assets/images/fxlegends/btc1.png"),
        //   currency: "btc",
        // },
        // {
        //   value: "NOW_PAYMENT3",
        //   title: "etc",
        //   img: require("@/assets/images/fxlegends/etc.png"),
        //   currency: "etc",
        // },
      ],
      required,
    };
  },
  watch: {
    async payWithWallet(val) {
      if (val) {
        try {
          const { data } = await this.$http.get("panel/profile/user/wallet");
          this.currentBalance = data.current_balance;
          if (parseFloat(this.currentBalance) < parseFloat(this.paymentPrice)) {
            this.customPrice = parseFloat(this.currentBalance);
          } else {
            this.customPrice = parseFloat(this.paymentPrice);
          }
        } catch (error) {}
      } else {
        this.customPrice = "";
      }
    },
  },
  methods: {
    pay() {
      this.$refs.pay.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            let pay = {};
            if (!this.payWithWallet) {
              pay = {
                type: this.type.includes("STRIPE") ? "STRIPE" : "NOW_PAYMENT",
              };
              !this.type.includes("STRIPE") && (pay.currency = this.currency);
            } else {
              if (
                parseFloat(this.currentBalance) < parseFloat(this.paymentPrice)
              ) {
                pay = {
                  type: this.type.includes("STRIPE") ? "STRIPE" : "NOW_PAYMENT",
                  use_wallet: this.customPrice,
                };
                !this.type.includes("STRIPE") && (pay.currency = this.currency);
              } else {
                pay = {
                  use_wallet: this.customPrice,
                };
                if (
                  parseFloat(this.customPrice) < parseFloat(this.paymentPrice)
                ) {
                  pay = {
                    type: this.type.includes("STRIPE")
                      ? "STRIPE"
                      : "NOW_PAYMENT",
                    use_wallet: this.customPrice,
                  };
                  !this.type.includes("STRIPE") &&
                    (pay.currency = this.currency);
                }
              }
            }

            const { data } = await this.$http.post(
              this.$route.fullPath.includes("competition")
                ? `/panel/competitions/${this.item.id}/pay`
                : `/panel/plans/${this.item.id}/subscribe`,
              { ...pay }
            );
            if (data.pay_with_wallet) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Payment done",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              window.location.assign(data.payment.url);
            }
          } catch (err) {}

          this.loading = false;
          this.showModal = false;
        }
      });
    },
  },
};
</script>
<style></style>
